import { AxiosInstanceProvider } from '../../../core/hooks';
import { DashboardHttpQueryConfig } from '../../config';
import { L3ServiceStatusGroupApiModel } from '../../model';

export interface L3ServiceStatusGroupHttpGetPayloadModel {
  customerId: number;
}

export type L3ServiceStatusGroupHttpGetResponseModel = L3ServiceStatusGroupApiModel[];

export const getL3ServiceStatusGroup = async (
  axios: AxiosInstanceProvider,
  { customerId }: L3ServiceStatusGroupHttpGetPayloadModel,
): Promise<L3ServiceStatusGroupHttpGetResponseModel> => {
  const response = await axios().get<L3ServiceStatusGroupHttpGetResponseModel>(
    DashboardHttpQueryConfig['GetL3ServiceStatusGroup'].url.replace('{customerId}', customerId.toString(10)));
  return response.data;
};